import React from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './app/App';
import './app/styles.css';
import { installTestHooks } from './app/testHooks';

const container = document.getElementById('root');
if (!container) throw new Error('#root is missing from index.html');

installTestHooks();

createRoot(container).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
